const actions = {
  FIRESTORE: "FIRESTORE",
  firestore: payload => ({
    type: actions.FIRESTORE,
    payload
  })
};
export default actions;
